export default __webpack_public_path__ + "static/radio-icons-4c6be3d5c8d663514147051958286dc9.svg";